import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import ReactSelect from 'react-select'

import { Div } from 'ui'
import { primary } from './variants'
import { baseStyles } from './styles'
import { useEffect } from 'react'


const Select = ({
  selected,
  onChange,
  options,
  name,
  variant = 'primary',
  size,
  placeholder,
  // getOptionValue = (i) => i.value
  formatOptionLabel,
  hideChevron,
  icon: Icon,
  iconSize = 20,
  isSearchable
}) => {

  const theme = useTheme()
  const { t, i18n } = useTranslation()

  const hasIcon = !!Icon

  const dropdownIndicator = hideChevron
    ? { DropdownIndicator: null }
    : {}


  const getStyles = () => {
    if (variant === 'primary') return primary({ theme, size, hasIcon })

    return baseStyles(theme, size, hasIcon)
  }


  /**
   * Hack to internationalize the selected option
   * because is scoped and doesnt change itself
   */
  useEffect(() => {
    if (!selected || !options.length) return

    const current = options.find(opt => opt.value === selected?.value)
    onChange(current)
  }, [i18n.language])


  return (
    <Div position='relative'>
      <ReactSelect
        // autoFocus
        // menuIsOpen
        // backspaceRemovesValue={false}
        components={{
          IndicatorSeparator: null,
          ...dropdownIndicator
        }}
        // controlShouldRenderValue={false}
        hideSelectedOptions={false}
        isClearable={false}
        onChange={onChange}
        options={options}
        // getOptionValue={getOptionValue}
        // getOptionLabel={getOptionLabel}
        placeholder={placeholder || t('selectOption')}
        name={name}
        // styles={selectStyles(theme) as StylesConfig<Option, false>}
        // tabSelectsValue={false}
        value={selected}
        isSearchable={isSearchable}
        styles={getStyles()}
        formatOptionLabel={formatOptionLabel}
      />

      {hasIcon && (
        <Div
          position='absolute'
          top='50%'
          left={10}
          transform='translateY(-50%)'
          display='grid'
          pointerEvents='none'
        >
          <Icon
            width={iconSize}
            height={iconSize}
          />
        </Div>
      )}
    </Div>
  )
}

export default Select